import React from "react";
import { connect } from "react-redux";
import FilmalityCircularProgress from "../../../../shared/filmality-circular-progress";
import Costume from "./costume";
import Errors from "../../../../shared/errors";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName,
  OnboardingStep3ClassName,
  OnboardingStep4ClassName
} from "./ducks/reducer";
import Onboarding from '../../../../shared/onboarding/onboarding';
import confirm from "../../../../shared/modal/confirm";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Overview(props) {
  const {
    overview,
    filmId,
    errors,
    warnings,
    characterOrderBy,
    onboardingSteps,
    aliasCostume,
    unaliasCostume,
    costumesAcquiredPercentage,
    processingCostumeIds,
    deleteMultipleCostumes,
    readOnly
  } = props;

  const [selectedCostumeIds, setSelectedCostumeIds] = React.useState<number[]>([]);

  const toggleCostumeSelection = (costumeId: number) => {
    setSelectedCostumeIds(prev =>
      prev.includes(costumeId)
        ? prev.filter(id => id !== costumeId)
        : [...prev, costumeId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedCostumeIds.length === overview.costumes?.length) {
      setSelectedCostumeIds([]);
    } else {
      setSelectedCostumeIds(overview.costumes?.map(c => c.id) || []);
    }
  };

  const deleteMultipleCostumesLocal = (filmId, selectedCostumeIds) => {
    deleteMultipleCostumes(filmId, selectedCostumeIds);
    setSelectedCostumeIds([]);
  };

  const handleDeleteSelected = () => {
    if (selectedCostumeIds.length === 0) return;
    confirm(() => deleteMultipleCostumesLocal(filmId, selectedCostumeIds), null, `Are you sure you want to delete ${selectedCostumeIds.length} costume${selectedCostumeIds.length !== 1 ? 's' : ''}?`, "Delete Costumes");
  };


  function CostumesList() {
    const allSelected = selectedCostumeIds.length === overview.costumes?.length && overview.costumes?.length > 0;

    return (
      <table className={`${OnboardingStep3ClassName} table`}>
        <thead>
          <tr>
            {!readOnly && (
              <th>
                <FilmanizeCheckbox
                  checked={allSelected}
                  onChange={toggleSelectAll}
                />
              </th>
            )}
            <th>Name</th>
            <th>Script Days</th>
            <th>Acquisition Method</th>
            <th>Acquired</th>
          </tr>
        </thead>
        <tbody>
          {(overview.costumes || []).map((costume, index) => {
            return (
              <Costume
                key={index}
                index={index}
                costume={costume}
                filmId={filmId}
                readOnly={readOnly}
                aliasCostume={aliasCostume}
                unaliasCostume={unaliasCostume}
                processingCostumeIds={processingCostumeIds}
                isSelected={selectedCostumeIds.includes(costume.id)}
                onToggleSelect={() => toggleCostumeSelection(costume.id)}
              />
            );
          })}
        </tbody>
      </table>
    );
  }


  return (
    <div>
      <div className="columns">
        <div
          className={`${OnboardingStep1ClassName} circular-progress column`}>
          <FilmalityCircularProgress
            percentage={costumesAcquiredPercentage}
            title="Costumes Acquired"
          />
        </div>
      </div>
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}
      <div className={OnboardingStep2ClassName}>
        <div className="columns">
          <div className="column">
            <CostumesList />
          </div>
        </div>
      </div>
      <div className="mt-1 buttons">
        {!readOnly && overview.costumes?.length > 0 && (
          <button
            className="button is-danger"
            onClick={handleDeleteSelected}
            disabled={selectedCostumeIds.length === 0}
          >
            Delete Selected ({selectedCostumeIds.length})
          </button>
        )}
      </div>

      <Onboarding onboardingSteps={onboardingSteps} section="Costumes Overview" />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    charactersOnboardingSteps:
      state.charactersState.overviewState.charactersOnboardingSteps
  };
}

export default connect(mapStateToProps, {
})(Overview);
